import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CONFIG from "./constants/config";
import { trackPageView } from "./analytics";

/**
 * Tracks page views in GA4 when the route changes (SPA navigation).
 * Place inside Router so useLocation works.
 */
function GoogleAnalytics() {
  const location = useLocation();
  const baseFolder = CONFIG.BASE_FOLDER;

  useEffect(() => {
    const fullPath = baseFolder
      ? `/${baseFolder}${location.pathname}${location.search}`
      : location.pathname + location.search;
    trackPageView(fullPath);
  }, [location.pathname, location.search, baseFolder]);

  return null;
}

export default GoogleAnalytics;
